
export default {
  name: 'ApiHeader',
  methods: {
    copyerr() {
      this.$toast.fail('复制失败')
    },
    copyon() {
      this.$toast.success('复制成功')
    },
    // 重置token
    resetToken() {
      this.$dialog.confirm({
        title: '提示',
        message: '是否确认要重置Token?'
      }).then(async () => {
        const {data} = await this.$http.post('/users/tokenreset')
        if (data.status === 'success') {
          this.$store.commit('setOther', {
            name: 'token',
            value: data.token
          })// 密钥
          localStorage.setItem('key', data.token)
          this.$toast.success('重置成功')
        } else {
          this.$notify({type:'danger',message: data.msg})
        }
      }).catch(() => {
      })
    },
  }
}
